export type Preferences = { locale: string | null; timezone: string | null };

const KEY = 'pickpro.preferences';

export const readPreferences = (storage?: Storage): Preferences => {
  try {
    const raw = (storage ?? globalThis.window?.localStorage)?.getItem(KEY);
    if (!raw) return { locale: null, timezone: null };
    const parsed = JSON.parse(raw) as Partial<Preferences>;
    return {
      locale: typeof parsed.locale === 'string' ? parsed.locale : null,
      timezone: typeof parsed.timezone === 'string' ? parsed.timezone : null,
    };
  } catch {
    return { locale: null, timezone: null };
  }
};

export const writePreferences = (preferences: Partial<Preferences>, storage?: Storage): void => {
  try {
    const target = storage ?? globalThis.window?.localStorage;
    target?.setItem(KEY, JSON.stringify({ ...readPreferences(target), ...preferences }));
  } catch {
    return;
  }
};
